// src/features/business-functions/components/workspaces/WorkspaceEmptyState.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import { CAMPAIGN_COPY } from '../../constants/campaignCopy';

/**
 * Empty state shown when no workspaces exist for the account.
 */
export default function WorkspaceEmptyState({ styles, error }) {
  return (
    <Box sx={styles.workspaceEmptyRoot}>
      <FolderOpenIcon sx={styles.workspaceEmptyIcon} />
      <Typography sx={styles.workspaceEmptyTitle}>
        {CAMPAIGN_COPY.empty.title}
      </Typography>
      <Typography sx={styles.workspaceEmptySubtitle}>
        {error
          ? CAMPAIGN_COPY.empty.loadError
          : CAMPAIGN_COPY.empty.noAccess}
      </Typography>
    </Box>
  );
}
